import { getRequest, postRequest } from "../app/postRequest.service";
import { PolicyDocumentsResponse } from "../interfaces/policyDocuments.interface";
import { ClaimDetailsResponseDTO, FetchAllClaimDetails } from "../interfaces/signup.interface";

export function fetchAllClaimDetailsApi(payload: FetchAllClaimDetails) {
  return new Promise<{ data: ClaimDetailsResponseDTO }>((resolve) =>
    resolve(postRequest('/claim/checkClaimStatus',payload))
  );
}